import React, { createContext, useContext, useRef, useCallback } from "react"

const VideoPlayerContext = createContext()

export const useVideoPlayer = () => {
  const context = useContext(VideoPlayerContext)
  if (!context) {
    throw new Error("useVideoPlayer must be used within a VideoPlayerProvider")
  }
  return context
}

export const VideoPlayerProvider = ({ children }) => {
  const videoPlayersRef = useRef(new Map()) // Map of videoId -> { vimeoPlayer, videoElement, pauseFn }

  const registerVideo = useCallback((videoId, playerData) => {
    videoPlayersRef.current.set(videoId, playerData)
  }, [])

  const unregisterVideo = useCallback((videoId) => {
    videoPlayersRef.current.delete(videoId)
  }, [])

  const pauseAllOtherVideos = useCallback((currentVideoId) => {
    videoPlayersRef.current.forEach((playerData, videoId) => {
      if (videoId !== currentVideoId) {
        try {
          if (playerData.pauseFn) {
            playerData.pauseFn()
          }
        } catch (error) {
          console.warn(`Error pausing video ${videoId}:`, error) // eslint-disable-line no-console
        }
      }
    })
  }, [])

  const value = {
    registerVideo,
    unregisterVideo,
    pauseAllOtherVideos
  }

  return <VideoPlayerContext.Provider value={value}>{children}</VideoPlayerContext.Provider>
}
